
export type CourseType = typeof CourseTypes[number];
export const CourseTypes = [
    'Mandatory',
    'Supplementary'
] as const;

export class Course {
    constructor(
        public id:string,
        public provider:string,
        public type:CourseType,
        public title:string,
        public description:string,
        public days:Date[],
        public signupDeadline:Date,
        public location:string, 
        public contactURL:string,
        public contactEmail:string,
        public contactPhone:string
    ){}
}